import { useContext } from 'react';

import { CallContext } from './call-context';

// ----------------------------------------------------------------------

export function useCallContext() {
  const context = useContext(CallContext);

  if (!context) throw new Error('useCheckoutContext must be use inside CheckoutProvider');

  return context;
}
